<script setup>
import { computed, defineProps, getCurrentInstance } from 'vue'
import { useStore } from '@/utils/VuexHelpers'

const props = defineProps({
  productId: {
    type: Number,
    default: null
  },
  display: {
    type: String,
    default: 'code-name', // options: code, name, code-name
    validator: (value) => ['code', 'name', 'code-name'].includes(value)
  },
  fallback: {
    type: String,
    default: '-'
  },
  maxNameLength: {
    type: Number,
    default: null
  }
})

const vm = getCurrentInstance().proxy
const store = useStore()

const productNames = computed(() => store.getters.productNames || [])
const loadingProducts = computed(() => store.getters.loadingProducts)

const product = computed(() => {
  if (!props.productId) return null

  return productNames.value.find((item) => {
    return Number(item.id) === Number(props.productId)
  })
})

const truncateText = (value, maxLength) => {
  if (!value) return ''

  if (!maxLength || value.length <= maxLength) {
    return value
  }

  return `${value.slice(0, maxLength)}...`
}

const productLabel = computed(() => {
  if (!props.productId) return props.fallback

  if (loadingProducts.value === 'names' && !product.value) {
    return 'Loading...'
  }

  if (!product.value) return props.fallback

  const code = product.value.code || ''
  const name = truncateText(product.value.product || '', props.maxNameLength)

  if (props.display === 'code') return code || props.fallback
  if (props.display === 'name') return name || props.fallback

  if (code && name) return `${code} - ${name}`

  return code || name || props.fallback
})

const fullProductLabel = computed(() => {
  if (!product.value) return props.fallback

  const code = product.value.code || ''
  const name = product.value.product || ''

  if (props.display === 'code') return code || props.fallback
  if (props.display === 'name') return name || props.fallback

  if (code && name) return `${code} - ${name}`

  return code || name || props.fallback
})

if (productNames.value.length === 0 && loadingProducts.value !== 'names') {
  store.dispatch('fetchProductNames', { vm })
}
</script>

<template>
  <span :title="fullProductLabel">
    {{ productLabel }}
  </span>
</template>
